import { Process } from "../../../../lib/process/process.cls";
import { WsConnector } from "../../../../lib/ws/ws-connector.cls";
import { Const } from '../../../../commonAll/provider/lib/const.cls';
const moment = require('moment');
const Buffer = require('buffer').Buffer;
const zlib = require('zlib');
let typingTimer, oldConnection = false;
function handleKeyUp() {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
        try {
            if (window['myStxx'] && window['myStxx'].tfc._isOpen) {
                window['myStxx'].tfc.updateData();
            }
        }
        catch (e) {
            console.log(e);
        }
    }, 2000);
}
let wsTimer, tradeDebounce, historyDebounce, reconnect = false;
export class PriceFeedSeeder extends Process {
    constructor(iProvider) {
        super(iProvider);
        /**
         * HTML5 WebSocket wrapper
         */
        this.wsConnector = null;
        this.compression = true;
        this.rawFeed = true;
        //public msgpack : boolean = false;
        this.onopen = (ev) => {
            // this.log(PriceFeedSeeder.TAG, 'open connection at url' + 
            //   this.settings.ENDPOINT)
            try {
                const _that = this;
                const vuexStore = _that.iProvider.getStore();
                vuexStore.commit(Const.SET_WS_STATUS, 1); // 0:'yellow',1:'green',2:'orange',3:'red' 
                this.auth(Object.assign(Object.assign({ auth: (this.iProvider.settings.token || ''), defaults: this.settings.defaultIsinIds }, (this.compression === false ? { "compression": this.compression } : {})), { "rawFeed": this.rawFeed }));
            }
            catch (ex) { }
        };
        /**
         * handle message from webocket
         */
        this.heartbeat = 0;
        this.onmessage = (ev) => {
            try {
                const _that = this;
                const vuexStore = _that.iProvider.getStore();
                vuexStore.commit(Const.SET_WS_STATUS, 1); // 0:'yellow',1:'green',2:'orange',3:'red'
                var responseBuffer = new Buffer(ev.data, 'base64');
                // var responseBuffer = new Buffer(ev.data, 'binary');
                zlib.unzip(responseBuffer, function (err, buffer) {
                    if (!err) {
                        let jsonMsg = JSON.parse(buffer.toString());
                        clearInterval(wsTimer);
                        wsTimer = setInterval(() => {
                            try {
                                // console.log('onmessage----------=============------->')
                                // console.log(Object.keys(_that.iProvider.iCache.cacheEntries))-------1-------=onconnecting>
                                // console.log('onmessage----------------->')
                                reconnect = true;
                                _that.wsConnector.stop(_that.settings);
                                _that.start(_that.settings);
                                oldConnection = true;
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }, 20000);
                        if (Object.keys(jsonMsg).length != 0) {
                            // this.log(PriceFeedSeeder.TAG, 'onmessage', jsonMsg)
                            if ('MC' in jsonMsg) {
                                console.log('jsonMsg.MC====>', jsonMsg.MC);
                                let marginCallClose = jsonMsg.MC;
                                marginCallClose['msg_type'] = 'MC'; //equity warning
                                // marginCallClose['msg'] = 'Position #'+marginCallClose.OrderID+' has been closed due to margin call.' 
                                if (marginCallClose.MarginCall == 'MC' && (marginCallClose.ClosedTrades || []).length) {
                                    marginCallClose['title'] = 'Margin Call!';
                                    marginCallClose['msg'] = `Position ${marginCallClose.ClosedTrades.length ? 's' : ''} #[${marginCallClose.ClosedTrades.join(', ')}] have been closed due to Margin call`;
                                }
                                else if (marginCallClose.MarginCall == 'MC2' && (marginCallClose.HedgedTrades || []).length) {
                                    marginCallClose['title'] = 'Margin Call!';
                                    marginCallClose['msg'] = `Position ${marginCallClose.HedgedTrades.length ? 's' : ''} #[${marginCallClose.HedgedTrades.join(', ')}] has been hedged due to Margin call`;
                                }
                                else if (marginCallClose.MarginCall == 'MC3' && (marginCallClose.ClosedTrades || []).length) {
                                    marginCallClose['title'] = 'Margin Call!';
                                    marginCallClose['msg'] = `Position ${marginCallClose.ClosedTrades.length ? 's' : ''} #[${marginCallClose.ClosedTrades.join(', ')}] has been closed due to Margin call`;
                                }
                                else if (marginCallClose.MarginCall == 'MC' && (marginCallClose.ClosedTrades || []).length == 0 && (marginCallClose.HedgedTrades || []).length == 0) {
                                    marginCallClose['title'] = 'Margin Call!';
                                    marginCallClose['msg'] = 'Some positions will be closed!';
                                }
                                if (marginCallClose.msg) {
                                    let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                    active_notification.push(marginCallClose);
                                    vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                }
                            }
                            if ("equity_warning" in jsonMsg) {
                                // console.log('jsonMsg.equity_warning====>',jsonMsg.equity_warning)
                                let eqtyWarning = jsonMsg.equity_warning;
                                eqtyWarning['msg_type'] = 'EW'; //equity warning
                                eqtyWarning['msg'] = 'Equity has reached ' + eqtyWarning.EquityNotificationPercentLevel + '% of Used Margin.';
                                let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                active_notification.push(eqtyWarning);
                                vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                            }
                            if ('orderbook' in jsonMsg) {
                                // console.log('orderbook-------------->',jsonMsg.orderbook)
                                let orderbook = vuexStore.getters[Const.GET_ORDER_BOOK];
                                // console.log('1---------------------->',vuexStore.getters[Const.GET_ORDER_BOOK])
                                for (let key in jsonMsg.orderbook) {
                                    if (!orderbook[jsonMsg.orderbook[key].m]) {
                                        orderbook[jsonMsg.orderbook[key].m] = jsonMsg.orderbook[key];
                                    }
                                    else {
                                        for (let buy_sell of ['buy', 'sell']) {
                                            // console.log('========================>',buy_sell)
                                            if (orderbook[jsonMsg.orderbook[key].m][buy_sell]) {
                                                if (orderbook[jsonMsg.orderbook[key].m][buy_sell].length) {
                                                    for (let i = 0; i < jsonMsg.orderbook[key][buy_sell].length; i++) {
                                                        let item_i = jsonMsg.orderbook[key][buy_sell][i];
                                                        // console.log('item_i------------------>',item_i)
                                                        let change = false;
                                                        for (let j = 0; j < orderbook[jsonMsg.orderbook[key].m][buy_sell].length; j++) {
                                                            let item_j = orderbook[jsonMsg.orderbook[key].m][buy_sell][j];
                                                            // console.log('item_j------------------>',item_j)
                                                            if (parseFloat(item_j.Rate) == parseFloat(item_i.Rate)) {
                                                                orderbook[jsonMsg.orderbook[key].m][buy_sell][j]['Quantity'] = item_i['Quantity'];
                                                                orderbook[jsonMsg.orderbook[key].m][buy_sell][j]['Partial'] = item_i['Partial'];
                                                                change = true;
                                                            }
                                                            /*if(item_j['Quantity'] == item_i['Quantity']){
                                                              change = true;
                                                            }*/
                                                        }
                                                        if (!change) {
                                                            orderbook[jsonMsg.orderbook[key].m][buy_sell].unshift(item_i);
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                orderbook[jsonMsg.orderbook[key].m][buy_sell] = jsonMsg.orderbook[key][buy_sell];
                                            }
                                            // orderbook[jsonMsg.orderbook[key].m][buy_sell] = orderbook[jsonMsg.orderbook[key].m][buy_sell].slice(0, 6)
                                            //Stopped from here===================>
                                            // orderbook[jsonMsg.orderbook[key].m][buy_sell].sort((a, b) => {
                                            //   if (b.Rate > a.Rate) return 1
                                            //   if (b.Rate < a.Rate) return -1
                                            //   return 0
                                            // })
                                            // if(buy_sell == 'sell'){
                                            //   orderbook[jsonMsg.orderbook[key].m][buy_sell].reverse()
                                            // }
                                        }
                                    }
                                }
                                vuexStore.commit(Const.SET_ORDER_BOOK, orderbook);
                                // console.log('2---------------------->',orderbook)
                                // console.log('---------------------------------------------------------------------------')
                            }
                            if ('message' in jsonMsg && Object.keys(jsonMsg.message).length > 0 && typeof (jsonMsg.message) == 'object') {
                                // console.log('message====>',jsonMsg.message)
                                // console.log('message_______________',jsonMsg.message)
                                if ('price_alert' in jsonMsg.message) { // on auth, su
                                    // console.log('price_alert====>',jsonMsg.message.price_alert)
                                    let price_alert = jsonMsg.price_alert;
                                    price_alert['msg_type'] = 'T';
                                    let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                    active_notification.push(price_alert);
                                    vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                }
                                if ('account' in jsonMsg.message) {
                                    // console.log('account====>',jsonMsg.message.account)
                                    /*let a = {
                                      "AccountID":5653,
                                      "Action":"U",
                                      "Balance":108500,
                                      "Currency":"USD",
                                      "Income":500,
                                      "State":"",
                                      "TraderID":11350,
                                      "Type":"DEPOSIT_WITHDRAW"
                                    }*/ // demo data coming from websocket
                                    if (jsonMsg.message.account.Balance) {
                                        let balance = Object.assign({}, vuexStore.getters[Const.GET_ACCOUNT_BALANCE]);
                                        balance['AMOUNT'] = jsonMsg.message.account.Balance;
                                        vuexStore.commit(Const.SET_ACCOUNT_BALANCE, balance);
                                    }
                                }
                                if ("equitywarning" in jsonMsg.message) {
                                    console.log('jsonMsg.message.equitywarning====>', jsonMsg.message.equitywarning);
                                    let eqtyWarning = jsonMsg.message.equitywarning;
                                    eqtyWarning['msg_type'] = 'EW'; //equity warning
                                    eqtyWarning['title'] = 'Account Equity Warning!';
                                    eqtyWarning['msg'] = 'Equity has reached ' + eqtyWarning.EquityNotificationPercentLevel + '% of Used Margin.';
                                    let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                    active_notification.push(eqtyWarning);
                                    vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                }
                                if ("minimalequity" in jsonMsg.message) {
                                    console.log('jsonMsg.message.minimalequity====>', jsonMsg.message.minimalequity);
                                    let minimalequity = jsonMsg.message.minimalequity;
                                    if (minimalequity.MarginCall && ['MC', 'MC2', 'MC3'].includes(minimalequity.MarginCall)) {
                                        minimalequity['msg_type'] = 'MC';
                                        if (minimalequity.MarginCall == 'MC' && (minimalequity.ClosedTrades || []).length) {
                                            minimalequity['title'] = 'Margin Call!';
                                            minimalequity['msg'] = `Position${minimalequity.ClosedTrades.length ? 's' : ''} #[${minimalequity.ClosedTrades.join(', ')}] have been closed due to Margin call`;
                                        }
                                        else if (minimalequity.MarginCall == 'MC2' && (minimalequity.HedgedTrades || []).length) {
                                            minimalequity['title'] = 'Margin Call!';
                                            minimalequity['msg'] = `Position${minimalequity.HedgedTrades.length ? 's' : ''} #[${minimalequity.HedgedTrades.join(', ')}] have been hedged due to Margin call`;
                                        }
                                        else if (minimalequity.MarginCall == 'MC3' && (minimalequity.ClosedTrades || []).length) {
                                            minimalequity['title'] = 'Margin Call!';
                                            minimalequity['msg'] = `Position${minimalequity.ClosedTrades.length ? 's' : ''} #[${minimalequity.ClosedTrades.join(', ')}] have been closed due to Margin call`;
                                        }
                                        else if (minimalequity.MarginCall == 'MC' && (minimalequity.ClosedTrades || []).length == 0 && (minimalequity.HedgedTrades || []).length == 0) {
                                            minimalequity['title'] = 'Margin Call!';
                                            minimalequity['msg'] = 'Some positions will be closed!';
                                        }
                                    }
                                    else {
                                        minimalequity['msg_type'] = 'EW'; //equity warning
                                        minimalequity['msg'] = `Account reached Minimal Equity level! Position #[${minimalequity.ClosedTrades.join(', ')}] has been closed due to Minimal Equity`;
                                    }
                                    let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                    active_notification.push(minimalequity);
                                    vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                }
                                //fecth order id
                                if ('resp_msg' in jsonMsg.message) {
                                    // console.log('resp_msg ---------------->' , jsonMsg.message)
                                    if (jsonMsg.message.tempOrderId) { // update new message by id
                                        let ws_order = Object.assign({}, vuexStore.getters[Const.GET_WS_ORDER]);
                                        // console.log('before',vuexStore.getters[Const.GET_WS_ORDER])
                                        ws_order[jsonMsg.message.tempOrderId] = jsonMsg.message;
                                        vuexStore.commit(Const.SET_WS_ORDER, ws_order);
                                        // console.log('after',vuexStore.getters[Const.GET_WS_ORDER])
                                    }
                                }
                                if ('create_alert' in jsonMsg.message) {
                                    let price_alert = jsonMsg.message.create_alert;
                                    price_alert['msg_type'] = 'I';
                                    let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                    active_notification.push(price_alert);
                                    vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                }
                                if ('update_alert' in jsonMsg.message) {
                                    // console.log('--------------------------->',jsonMsg.message.update_alert)
                                    let price_alert = jsonMsg.message.update_alert;
                                    price_alert['msg_type'] = 'U';
                                    let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                    active_notification.push(price_alert);
                                    vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                }
                                if ('remove_alert' in jsonMsg.message) {
                                    let upData = jsonMsg.message.remove_alert;
                                    if (upData.type == 'active') {
                                        let create_alert = vuexStore.getters[Const.GET_ACTIVE_PRICE_ALERT];
                                        let newList = create_alert.filter(val => val.AlertID != upData.AlertID);
                                        // console.log('active',newList)
                                        vuexStore.commit(Const.SET_ACTIVE_PRICE_ALERT, newList);
                                    }
                                    else if (upData.type == 'triggered') {
                                        let create_alert = vuexStore.getters[Const.GET_TRIGGERED_PRICE_ALERT];
                                        let newList = create_alert.filter(val => val.AlertID != upData.AlertID);
                                        // console.log('triggered',newList)
                                        vuexStore.commit(Const.SET_TRIGGERED_PRICE_ALERT, newList);
                                    }
                                }
                                if ('tradeupdate' in jsonMsg.message && Object.keys(jsonMsg.message.tradeupdate).length > 0) {
                                    // console.log('-------tradeupdate---------->',jsonMsg.message.tradeupdate)
                                    let date = moment(jsonMsg.message.tradeupdate.OpenTime).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
                                    let trade = Object.assign(Object.assign({}, jsonMsg.message.tradeupdate), { date });
                                    let openTradeList = vuexStore.getters[Const.GET_OPEN_TRADE];
                                    let newList = openTradeList.filter(val => val.TradeID != trade.TradeID);
                                    if ('Action' in jsonMsg.message.tradeupdate && jsonMsg.message.tradeupdate.Action == "I") {
                                        delete trade.Action;
                                        newList.unshift(trade);
                                        vuexStore.commit(Const.SET_OPEN_TRADE, newList);
                                        handleKeyUp();
                                    }
                                    else if ('Action' in jsonMsg.message.tradeupdate && jsonMsg.message.tradeupdate.Action == "D") {
                                        vuexStore.commit(Const.SET_OPEN_TRADE, newList);
                                        handleKeyUp();
                                        let inputData = { 'globalParams': {
                                                FROM_DATE: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                                TO_DATE: moment().format('YYYY-MM-DD'),
                                            }, 'localParams': { parameter: { pageLoader: false }, 'from': 'ws' } };
                                        vuexStore.commit(Const.SET_CALL_TRADE_HISTORY_API, true);
                                        // clearTimeout(historyDebounce)
                                        // historyDebounce = setTimeout(()=>{
                                        //   vuexStore.dispatch(Const.RUN_GET_TRADE_HISTORY, inputData);
                                        // },1000)
                                    }
                                    else if ('Action' in jsonMsg.message.tradeupdate && jsonMsg.message.tradeupdate.Action == "U") {
                                        // console.log('Action == "U"====>',jsonMsg.message.tradeupdate)
                                        if (trade.Quantity || trade.Interest) {
                                            openTradeList.forEach((val, index) => {
                                                if (openTradeList[index].TradeID == trade.TradeID) {
                                                    // console.log('====trade========>',openTradeList[index], trade)
                                                    // console.log('====update========>',{...openTradeList[index],...trade})
                                                    // if(openTradeList[index].Quantity != trade.Quantity){
                                                    //   openTradeList[index].Quantity = trade.Quantity
                                                    // }
                                                    openTradeList[index] = Object.assign(Object.assign({}, openTradeList[index]), trade);
                                                }
                                            });
                                            vuexStore.commit(Const.SET_OPEN_TRADE, openTradeList);
                                            handleKeyUp();
                                        }
                                        if (trade.Partial) {
                                            let inputData = { 'globalParams': {
                                                    FROM_DATE: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                                    TO_DATE: moment().format('YYYY-MM-DD'),
                                                }, 'localParams': { parameter: { pageLoader: false }, 'from': 'ws' } };
                                            clearTimeout(historyDebounce);
                                            historyDebounce = setTimeout(() => {
                                                vuexStore.dispatch(Const.RUN_GET_TRADE_HISTORY, inputData);
                                            }, 1000);
                                        }
                                    }
                                }
                                if ('orderupdate' in jsonMsg.message && Object.keys(jsonMsg.message.orderupdate).length > 0) {
                                    // console.log('--------orderupdate--------->',jsonMsg.message.orderupdate)
                                    let date = moment(jsonMsg.message.orderupdate.OpenTime).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
                                    let order = Object.assign(Object.assign({}, jsonMsg.message.orderupdate), { date });
                                    let openorderList = vuexStore.getters[Const.GET_PENDING_ORDER];
                                    let newList = openorderList.filter(val => val.OrderID != order.OrderID);
                                    let delList = openorderList.filter(val => val.OrderID == order.OrderID);
                                    if ('Action' in jsonMsg.message.orderupdate && jsonMsg.message.orderupdate.Action == "I") {
                                        delete order.Action;
                                        newList.unshift(order);
                                        vuexStore.commit(Const.SET_PENDING_ORDER, newList);
                                    }
                                    else if ('Action' in jsonMsg.message.orderupdate && jsonMsg.message.orderupdate.Action == "D") {
                                        vuexStore.commit(Const.SET_PENDING_ORDER, newList);
                                        let inputData = {
                                            'globalParams': {
                                                'FROM_DATE': new Date(Date.now() - 30 * 24 * 3600 * 1000),
                                                'TO_DATE': new Date()
                                            },
                                            'localParams': { parameter: { pageLoader: false }, 'from': 'ws' }
                                        };
                                        // console.log('===============>',jsonMsg.message.orderupdate.Reason == "INSUFFICIENT_MARGIN")
                                        // console.log('===============>',delList)
                                        if (["INSUFFICIENT_MARGIN", "MIN_EQUITY"].includes(order.Reason) /*  == && delList.length > 0*/) {
                                            try {
                                                let minimalequity = {};
                                                let delOBJ = delList[0];
                                                const pendingType = { 'ES': 'Stop', 'EL': 'Limit', 'L': 'Limit', 'S': 'Stop' };
                                                const sideValue = { '0': 'Sell', '1': 'Buy' };
                                                const reasonMsg = {
                                                    'MIN_EQUITY': 'Insufficient equity.',
                                                    'INSUFFICIENT_MARGIN': 'Insufficient usable margin.'
                                                };
                                                minimalequity['msg_type'] = 'ME'; //equity warning
                                                // minimalequity['msg'] = `${sideValue[delOBJ.Side]} ${pendingType[delOBJ.Type]} order #${delOBJ.OrderID} to ${sideValue[delOBJ.Side]} ${delOBJ.Symbol} at ${delOBJ.Price} has been removed by the system due to: Insufficient usable margin.`;
                                                minimalequity['msg'] = `You order #${order.OrderID} to ${sideValue[order.Side]} ${order.Symbol} at ${order.Price} has been removed by the system due to:${reasonMsg[order.Reason]}`;
                                                console.log('INSUFFICIENT_MARGIN Object:=============> ', minimalequity);
                                                let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                                active_notification.push(minimalequity);
                                                vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                                            }
                                            catch (e) {
                                                console.log('INSUFFICIENT_MARGIN Error: ', e);
                                            }
                                        }
                                        if (delList.length > 0 && delList[0].type == 'C') {
                                            // vuexStore.dispatch(Const.RUN_GET_TRADE_HISTORY, inputData)
                                        }
                                        // else{
                                        //   clearTimeout(tradeDebounce)
                                        //   tradeDebounce = setTimeout(()=>{
                                        //     vuexStore.dispatch(Const.RUN_GET_REMOVED_TRADE_LIST, inputData);
                                        //   },1000)
                                        // }
                                    }
                                    else if ('Action' in jsonMsg.message.orderupdate && jsonMsg.message.orderupdate.Action == "U") {
                                        // if(order.Trail || order.Price || order.ToClose){
                                        openorderList.forEach((val, index) => {
                                            if (openorderList[index].OrderID == order.OrderID) {
                                                /*if(order.Trail && openorderList[index].Trail != order.Trail){
                                                  openorderList[index].Trail = order.Trail
                                                }
                                                if(order.Price && openorderList[index].Price != order.Price){
                                                  openorderList[index].Price = order.Price
                                                }*/
                                                openorderList[index] = Object.assign(Object.assign({}, openorderList[index]), order);
                                            }
                                        });
                                        vuexStore.commit(Const.SET_PENDING_ORDER, openorderList);
                                        // }
                                    }
                                    handleKeyUp();
                                }
                            }
                            if ('price_alert' in jsonMsg) { // on auth, su
                                // console.log('price_alert====>',jsonMsg.price_alert)
                                let price_alert = jsonMsg.price_alert;
                                price_alert['msg_type'] = 'T';
                                let active_notification = vuexStore.getters[Const.GET_PRICE_ALERT_NOTIFICATON];
                                active_notification.push(price_alert);
                                vuexStore.commit(Const.SET_PRICE_ALERT_NOTIFICATON, active_notification);
                            }
                            if ('isins' in jsonMsg) { // on auth, su
                                if ('subscribe' in jsonMsg) {
                                    // add the array of isin-ids to the cache
                                    _that.iProvider.addItems(jsonMsg);
                                    return;
                                }
                                else if ('unsubscribe' in jsonMsg) {
                                    // remove the array of isin-ids from the cache
                                    _that.iProvider.patchItems(jsonMsg, false);
                                }
                                return;
                            }
                            if (!('orderbook' in jsonMsg) && !('message' in jsonMsg) && !('isins' in jsonMsg) && !('price_alert' in jsonMsg)) {
                                // if(jsonMsg['EURGBP']){
                                //   console.log('----prev B ==>', {...jsonMsg['EURGBP']})
                                //   console.log('----prev B ==>', {...jsonMsg['EURGBP']}.B)
                                //   console.log('----prev A ==>', {...jsonMsg['EURGBP']}.A)
                                // }
                                // console.log(vuexStore.getters['/GET_CURRENCY_PAIRS'])
                                const instrumentsData = vuexStore.getters['/GET_CURRENCY_PAIRS'];
                                // const instrumentsDataObj = vuexStore.getters['/GET_CURRENCY_PAIRS_OBJECT']
                                const priceShift = vuexStore.getters['/GET_PRICE_SHIFT'] || {};
                                // console.log('-----priceShift----->', priceShift)
                                for (const key in jsonMsg) {
                                    const other = instrumentsData === null || instrumentsData === void 0 ? void 0 : instrumentsData.find(v => v.isinid == key);
                                    if (jsonMsg[key] && other) {
                                        jsonMsg[key]['other'] = other || jsonMsg[key].other || {};
                                    }
                                    if (_that.rawFeed && (priceShift.hasOwnProperty(key + 'B') || priceShift.hasOwnProperty(key + 'A'))) {
                                        if (priceShift.hasOwnProperty(key + 'B')) {
                                            jsonMsg[key].B += Number(priceShift[key + 'B']);
                                            jsonMsg[key].PSHFTB += Number(priceShift[key + 'B']);
                                        }
                                        if (priceShift.hasOwnProperty(key + 'A')) {
                                            jsonMsg[key].A += Number(priceShift[key + 'A']);
                                            jsonMsg[key].PSHFTA = Number(priceShift[key + 'A']);
                                        }
                                        // if(jsonMsg['EURGBP']){
                                        //   console.log('-New B-->', jsonMsg[key].B, 'Price shift B',Number(priceShift[key + 'B']))
                                        //   console.log('-New A-->', jsonMsg[key].A, 'Price shift A',Number(priceShift[key + 'A']))
                                        // }
                                    }
                                    // jsonMsg[key].B += Number(priceShift[key + 'B']) || 0;
                                    // jsonMsg[key].A += Number(priceShift[key + 'A']) || 0;
                                }
                                _that.iProvider.patchItems(jsonMsg);
                            }
                        }
                    }
                });
            }
            catch (exo) {
                console.log('ws-error ', exo);
                this.log(PriceFeedSeeder.TAG, 'onmessage EXC', exo);
            }
        };
        this.onclose = (ev) => {
            const vuexStore = this.iProvider.getStore();
            vuexStore.commit(Const.SET_WS_STATUS, 3); // 0:'yellow',1:'green',2:'orange',3:'red'
            this.log(PriceFeedSeeder.TAG, 'onclose...', ev);
        };
        this.onerror = (ev) => {
            const vuexStore = this.iProvider.getStore();
            vuexStore.commit(Const.SET_WS_STATUS, 2); // 0:'yellow',1:'green',2:'orange',3:'red'console.log(Object.keys(_that.iProvider.iCache.cacheEntries))
            this.log(PriceFeedSeeder.TAG, 'onerror...', ev);
        };
        this.onconnecting = () => {
            const vuexStore = this.iProvider.getStore();
            // console.log('-------1-------=onconnecting>')
            vuexStore.commit(Const.SET_WS_STATUS, 0); // 0:'yellow',1:'green',2:'orange',3:'red'
            this.log(PriceFeedSeeder.TAG, 'onconnecting...');
        };
    }
    sendMessage(jsonMsg) {
        try {
            let obj = Object.keys(jsonMsg)[0];
            if (jsonMsg[obj].localParams != undefined) {
                var localParams = jsonMsg[obj].localParams;
                delete jsonMsg[obj].localParams;
                this.wsConnector.send(JSON.stringify(jsonMsg), localParams);
            }
            else {
                this.wsConnector.send(JSON.stringify(jsonMsg), undefined);
            }
        }
        catch (ex) {
            console.log(ex);
            this.log(PriceFeedSeeder.TAG, 'sendMessage EXC', { jsonMsg, ex: ex.message });
        }
    }
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    auth(params) {
        try {
            this.sendMessage(params);
            let watchlist = localStorage.getItem('subList');
            /*if(this.iProvider.iCache.cacheEntries &&reconnect ){
              // this.watchlist(Object.keys(this.iProvider.iCache.cacheEntries))
            }*/
            if (watchlist) {
                watchlist = JSON.parse(watchlist);
                this.watchlist(watchlist);
            }
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, 'auth [ex]', ex.message);
        }
    }
    /**
     * @Override
     * subscribe tp a resource
     * @param ids either an array of ids or a key -> objecr mapping
     */
    watchlist(ids) {
        // ids = (ids instanceof Array) ? ids : this.mapping2keys(ids)
        this.sendMessage({ watchlist: ids });
        this.iProvider.heartbeat();
    }
    subscribe(ids) {
        // ids = (ids instanceof Array) ? ids : this.mapping2keys(ids)
        this.sendMessage({ subscribe: ids });
        // this.iProvider.heartbeat()
    }
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    unsubscribe(ids) {
        // ids = (ids instanceof Array) ? ids : this.mapping2keys(ids)
        this.sendMessage({ unsubscribe: ids });
        // this.iProvider.patchItems(ids, true)
    }
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    addFavorite(ids) {
        this.sendMessage({ addFavorite: ids });
        // this.iProvider.patchItems(ids, true)
    }
    removeFavorite(ids) {
        this.sendMessage({ removeFavorite: ids });
        // this.iProvider.patchItems(ids, true)
    }
    hedgePosition(ids) {
        this.sendMessage({ hedgePosition: ids });
        // this.iProvider.patchItems(ids, true)
    }
    placeOrder(ids) {
        this.sendMessage({ placeOrder: ids });
        // this.iProvider.patchItems(ids, true)
    }
    placepending(ids) {
        this.sendMessage({ placePending: ids });
        // this.iProvider.patchItems(ids, true)
    }
    cancelOrder(ids) {
        this.sendMessage({ cancelOrder: ids });
        // this.iProvider.patchItems(ids, true)
    }
    closeTrade(ids) {
        this.sendMessage({ closeTrade: ids });
        // this.iProvider.patchItems(ids, true)
    }
    modifyOrder(ids) {
        this.sendMessage({ modifyOrder: ids });
        // this.iProvider.patchItems(ids, true)
    }
    placestop(ids) {
        this.sendMessage({ placeStop: ids });
        // this.iProvider.patchItems(ids, true)
    }
    placeTrail(ids) {
        this.sendMessage({ placeTrail: ids });
        // this.iProvider.patchItems(ids, true)
    }
    placeLimit(ids) {
        this.sendMessage({ placeLimit: ids });
        // this.iProvider.patchItems(ids, true)
    }
    orderBook(ids) {
        this.sendMessage({ orderBook: ids });
        // this.iProvider.patchItems(ids, true)
    }
    createPriceAlert(ids) {
        this.sendMessage({ createPriceAlert: ids });
        // this.iProvider.patchItems(ids, true)
    }
    modifyPriceAlert(ids) {
        this.sendMessage({ modifyPriceAlert: ids });
        // this.iProvider.patchItems(ids, true)
    }
    removePriceAlert(ids) {
        this.sendMessage({ removePriceAlert: ids });
        // this.iProvider.patchItems(ids, true)
    }
    closeWs(params) {
        try {
            const vuexStore = this.iProvider.getStore();
            vuexStore.commit(Const.SET_WS_STATUS, 2); // 0:'yellow',1:'green',2:'orange',3:'red'
            this.wsConnector.stop(params);
        }
        catch (ex) {
            this.log('closing websocket', ex.message);
        }
    }
    /**
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    start(params) {
        this.settings = params;
        try {
            const vuexStore = this.iProvider.getStore();
            vuexStore.commit(Const.SET_WS_STATUS, 1); // 0:'yellow',1:'green',2:'orange',3:'red'
            this.settings.onopen = this.onopen;
            this.settings.onclose = this.onclose;
            this.settings.onconnecting = this.onconnecting;
            this.settings.onmessage = this.onmessage;
            this.wsConnector = new WsConnector();
            this.wsConnector.start(this.settings);
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, 'start [ex]', ex);
        }
    }
    /**
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    stop(params) {
        try {
            const vuexStore = this.iProvider.getStore();
            vuexStore.commit(Const.SET_WS_STATUS, 2); // 0:'yellow',1:'green',2:'orange',3:'red'
            this.closeWs(params);
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, "stop [ex]", ex);
        }
    }
}
PriceFeedSeeder.TAG = 'PriceFeedSeeder';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/seeder/price-feed-seeder.cls.ts
// module id = null
// module chunks = 